import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {TaskStatusEnum, TaskTypeEnum} from './constant'

export const homepage = createAsyncThunk(
  // [达人成长中心主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=174056994
  'Saada/live/hiya_socialize/female_center',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/female_center',
      {
        ...store.getState().env.otherInfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [等级中心页或者新手任务页领取奖励] http://wiki.xunlei.cn/display/~chenfeng8/acquire_female_task_reward
export const acquire_female_task_reward = createAsyncThunk(
  'Saada/live/hiya_socialize/acquire_female_task_reward',
  async (
    arg: {
      task_id?: string // 任务id，每日任务或者新手任务上报
      task_type: TaskTypeEnum // 任务类型，新手任务"novice_task",每日任务"daily_task",周任务"weekly_task"
      task_level: string // 任务等级，"N","B","A","S","SS"
      task_param?: number // 任务参数，周任务上报
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/hiya_socialize/acquire_female_task_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export interface IDailyTask {
  task_id: string // 任务id
  task_name: string // 任务内容
  task_level: string // 任务等级
  jump_url: string // 跳转链接
  task_icon: string // 任务icon
  reward_type: number // 奖励类型，1：珍珠
  reward_cnt: number // 奖励数量
  subtask_need_cnt: number // 单次任务目标完成次数
  subtask_cur_cnt: number // 单次任务累计完成次数
  task_status: TaskStatusEnum
}
export interface InitialStateType {
  home?: Partial<{
    name: string // 昵称
    avatar: string // 头像
    level: string // 等级（示例值："N"）
    level_dot: boolean // 是否有等级红点
    has_fast_channel: boolean // 是否有快升通道
    daily_income: number // 日收入
    wallet_income: number // 钱包收入
    online_time: number // 在线时长
    message_cnt: number // 发送消息数
    reply_rate_within_2_min: number // 2分钟内回复率
    daily_tasks_countdown: number // 日任务倒计时
    daily_tasks: {
      task_id: string // 任务id
      task_name: string // 任务内容
      task_level: string // 任务等级
      jump_url: string // 跳转链接
      task_icon: string // 任务icon
      reward_type: number // 奖励类型，1：珍珠
      reward_cnt: number // 奖励数量
      subtask_need_cnt: number // 单次任务目标完成次数
      subtask_cur_cnt: number // 单次任务累计完成次数
      task_status: TaskStatusEnum
    }[] // 日任务列表
    show_upgrade_popup: boolean // 是否展示升级弹窗
    has_daily_room_task: boolean // 是否有日房间任务
    week_task: {
      week_pearls: number // 本周实际获取的珍珠数
      max_target: number // 最高档位任务目标
      total_reward: number // 达成所有周目标后，获得的总珍珠数
      receive_reward: number // 在周任务中未领取的所有珍珠总和
      task_status: 0 | 1 | 2 // 任务状态：0=未完成，1=已完成待领取，2=已领取（全部领取完）
    } // 周任务信息
  }>
}

const initialState: InitialStateType = {
  home: {},
}

export const GrowthCenterSlice = createSlice({
  name: 'GrowthCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
  },
})
export default GrowthCenterSlice.reducer
export const GrowthCenterActions = GrowthCenterSlice.actions

export const useGrowthCenterState = () => {
  const data = useSelector((state) => {
    return state.SaadaGrowthCenter
  })
  return data
}
